import React from "react";
import PropTypes from "prop-types";

import StarringYou from "pages/Home/components/StarringYou";
import AlgoliaCardsPresenter from "presenters/AlgoliaCardsPresenter";
import AlgoliaLoadingIndicator from "components/AlgoliaLoadingIndicator";

import SearchBox from "./components/SearchBox";

const AlgoliaFeaturedEcards = ({ featuredEcards, loading }) => {
  const query = featuredEcards ? AlgoliaCardsPresenter.queryTerm(featuredEcards) : "";
  const id = AlgoliaCardsPresenter.id(featuredEcards);
  const loggerData = {
    contentfulId: id,
    query,
    component: "AlgoliaFeaturedEcards",
  };

  return (
    <>
      <AlgoliaLoadingIndicator loading={loading} loggerData={loggerData}>
        <StarringYou loading />;
      </AlgoliaLoadingIndicator>
      <SearchBox defaultRefinement={query} featuredEcards={featuredEcards} loading={loading} />
    </>
  );
};

AlgoliaFeaturedEcards.propTypes = {
  featuredEcards: PropTypes.shape(),
  loading: PropTypes.bool,
};

export default AlgoliaFeaturedEcards;
